export default function() {
  const navBtn = document.querySelector('.main-nav-toggle');
  const navLinks = document.querySelector('#navLinks');
  const navMain = document.querySelector('.header');
  const HTML = document.querySelector('html');
  let aria;

  setTimeout(function() {
    if (navLinks.style.top !== navMain.scrollHeight) {
      navLinks.style.top = navMain.scrollHeight + 'px';
    }
  }, 500);

  navBtn.addEventListener('click', function() {
    aria = navBtn.getAttribute('aria-expanded');

    if (aria === 'false') {
      navBtn.classList.add('active');
      navLinks.classList.remove('collapse');
      navLinks.classList.add('collapsing');
      addHeight();
      aria = 'true';
      navBtn.setAttribute('aria-expanded', 'true');
      HTML.style.overflow = 'hidden';
    } else if (aria === 'true') {
      navBtn.classList.remove('active');
      navLinks.classList.remove('show');
      navLinks.classList.remove('collapse');
      navLinks.classList.add('collapsing');
      addHeight();
      aria = 'false';
      navBtn.setAttribute('aria-expanded', 'false');
      HTML.style.overflow = 'auto';
    }

    transitionend(navLinks, aria);
  });

  let addHeight = function() {
    setTimeout(() => {
      if (navLinks.style.width !== '100%') {
        navLinks.style.width = '100%';
      } else if (navLinks.style.width === '100%') {
        navLinks.style.width = '';
      }
    }, 50);
  };

  let transitionend = function(collapse, aria) {
    collapse.addEventListener('transitionend', function(e) {
      if (e.propertyName === 'width' && aria === 'true') {
        collapse.classList.remove('collapsing');
        collapse.classList.add('collapse');
        collapse.classList.add('show');
      } else if (e.propertyName === 'width' && aria === 'false') {
        collapse.classList.remove('show');
        collapse.classList.remove('collapsing');
        collapse.classList.add('collapse');
      }
    });
  };
}
